import React from "react";

interface CompanyTool {
  readonly name: string;
  readonly logo: string;
  readonly bg: string;
}

const buildMonogramLogo = (label: string): string =>
  `data:image/svg+xml;utf8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <text
        x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        font-family="Arial, Helvetica, sans-serif"
        font-size="22"
        font-weight="700"
        fill="#FFFFFF"
      >
        ${label}
      </text>
    </svg>
  `)}`;

const tools: readonly CompanyTool[] = [
  {
    name: "AMN Healthcare",
    logo: buildMonogramLogo("AMN"),
    bg: "#0B5FFF",
  },
  {
    name: "Aya Healthcare",
    logo: buildMonogramLogo("AYA"),
    bg: "#6C2BD9",
  },
  {
    name: "CHG Healthcare",
    logo: buildMonogramLogo("CHG"),
    bg: "#00897B",
  },
  {
    name: "Cross Country Healthcare",
    logo: buildMonogramLogo("CC"),
    bg: "#F97316",
  },
  {
    name: "Robert Half",
    logo: buildMonogramLogo("RH"),
    bg: "#EF4444",
  },
  {
    name: "Adecco",
    logo: buildMonogramLogo("ADE"),
    bg: "#E11D48",
  },
  {
    name: "Randstad",
    logo: buildMonogramLogo("RND"),
    bg: "#2563EB",
  },
  {
    name: "ManpowerGroup",
    logo: buildMonogramLogo("MPG"),
    bg: "#1D4ED8",
  },
];

const CompaniesCarousel = (): React.ReactElement => {
  const radius: number = 160;
  const count: number = tools.length;

  return (
    <div className="wrapper2">
      <div className="circle2">
        {tools.map((tool, i) => {
          const angle: number = (360 / count) * i;

          return (
            <div
              key={tool.name}
              className="pill2"
              style={{
                backgroundColor: tool.bg,
                transform: `
                  rotate(${angle}deg)
                  translate(${radius}px)
                  rotate(-${angle}deg)
                `,
              }}
            >
              <div className="pill2__icon">
                <img src={tool.logo} alt={tool.name} />
              </div>
            </div>
          );
        })}
      </div>

      <style>{`
        .wrapper2 {
          width: 100%;
          padding: 48px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #ffffff;
        }

        .circle2 {
          position: relative;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          animation: rotateCircle 22s linear infinite;
        }

        .pill2 {
          position: absolute;
          top: 50%;
          left: 50%;

          width: 64px;
          height: 64px;

          margin: -32px;

          border-radius: 50%;

          display: flex;
          align-items: center;
          justify-content: center;

          box-shadow:
            0 4px 12px rgba(0,0,0,0.08),
            inset 0 0 0 1px rgba(255,255,255,0.15);

          transition: all 0.25s ease;
          cursor: default;
        }

        .pill2 img {
          width: 28px;
          height: 28px;
        }

        .pill2__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          animation: rotateCircleReverse 22s linear infinite;
        }

        @keyframes rotateCircle {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes rotateCircleReverse {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }
      `}</style>
    </div>
  );
}

export {CompaniesCarousel};